import PAGE_CONSTANTS from "./constant";

//Home Visit have BOTH Options
const HOME_VISIT = PAGE_CONSTANTS?.HOME_VISIT_TYPE
//Centre Visit have Only DC Option
const CENTRE_VISIT = PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE

const medicalTestsConfiguration = [
    {setName: "Set_0001",
     testList: "Physical MER",
     visitType: HOME_VISIT,
     allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_MAX_TIMING_FIVE_PM
    },
    {setName: "Set_0002",
        testList: "MER, ECG, Total Cholesterol, Hba1c, Sr Creatinine, CBC-ESR, Urine Routine, SGPT",
        visitType: HOME_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0003",
        testList: "MER, CBC-ESR, HbA1c, ECG, Lipid Profile, SGOT, SGPT, GGT, S. Creatinine, Uric acid, Urine Routine",
        visitType: HOME_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0004",
        testList: "MER, CBC-ESR, HbA1c, Lipid Profile, SGOT, SGPT, GGT, S. Creatinine, Uric acid, Urine Routine FBS, TMT, USG A AND P, CEA, HIV,",
        visitType: CENTRE_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0005",
        testList: "MER CBC -PS, HBA1C, Lipid profile, USG A& P, X Ray Chest, FBS TMT, CEA, HIV, LFT, RFT, Urine Routine, PSA, PAP SMEAR",
        visitType: CENTRE_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0006",
        testList: "MER, 2D Echo, CBC, Lipid Profile, Kidney Profile, LFT, TMT",
        visitType: CENTRE_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0007",
        testList: "MER,  HBA1C, 2D Echo, CBC, Lipid Profile, Kidney Function Test",
        visitType: CENTRE_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0008",
        testList: "MER, CBC-ESR, Lipid Profile, HbA1c, Sr. Creatinine, Urine Routine, SGOT, SGPT, GGT, TMT, Uric acid",
        visitType: CENTRE_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0009",
        testList: "MER, Urine Routine, FBS, CBC - PS, Sr Creatinine, Lipid Profile, TMT, USG Abdomen & Pelvis, HbA1c, X-Ray Chest, SGOT, SGPT, GGT, HBsAg, Uric acid",
        visitType: CENTRE_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0010",
        testList: "MER, Urine Routine, FBS, CBC-PS, Lipid Profile, TMT, USG Abd and Pelvis, HbA1c, X-Ray Chest, LFT, RFT, HBsAg, PAP smear (Female), PSA(Males), CEA, HIV",
        visitType: CENTRE_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0011",
        testList: "MER, CBC, FBS, Lipid Profile, SGOT, SGPT, GGT, Sr Creatinine, ECG",
        visitType: HOME_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0012",
        testList: "MER, CBC, FBS, ECG",
        visitType: CENTRE_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0013",
        testList: "MER, FBS, LIPIDS, ECG",
        visitType: HOME_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0014",
        testList: "MER, CBC-ESR, FBS, Lipid Profile, Sr. Creatinine, ECG",
        visitType: HOME_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0015",
        testList: "MER, ECG, FBS, CBC - ESR, Hb1Ac, Urine Routine, Lipid Profile, Liver Function Test, Renal Functioning Test, HbsAg, PSA, CEA and HIV",
        visitType: HOME_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0016",
        testList: "Females: MER, ECG, FBS, CBC - ESR, Hb1Ac, Urine Routine, Lipid Profile, Liver Function Rest, Renal Functioning Test, HbsAg, CEA and HIV",
        visitType: HOME_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0017",
        testList: "MER, CBC-ESR, FBS, Lipid Profile, Sr. Creatinine, ECG, CEA",
        visitType: HOME_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0018",
        testList: "MER, CBC, FBS, Lipid Profile, SGOT, SGPT, GGT, Sr Creatinine, ECG, CEA",
        visitType: HOME_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0019",
        testList: "MER, HbA1c,S Creatinine, SGPT, ECG, Lipid Profile, RUA",
        visitType: HOME_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0020",
        testList: "Males : MER, HbA1c, Urine Micro albumin, S Creatinine, Lipid Profile, PSA (Males), LFT, ECG, CEA",
        visitType: HOME_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0021",
        testList: "Females : MER, HbA1c, Urine Micro albumin, S Creatinine, Lipid Profile,  LFT, ECG, CEA",
        visitType: HOME_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0023",
        testList: "MER, CBC, HbA1c, Urine Routine, Lipid Profile, Sr Creatinine, BUN, CEA and HIV, HbsAg, Bilirubin, SGOT and SGPT",
        visitType: HOME_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0024",
        testList: "MER, CBC, HbA1c, Urine Routine, Lipid Profile, Sr Creatinine, BUN, CEA, HIV, HbsAg, Sr Bilirubin, SGOT and SGPT USG Abd + pelvis, ECG, HS-CRP",
        visitType: CENTRE_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    },
    {setName: "Set_0025",
        testList: "MER, Hba1c, Lipid profile and ECG",
        visitType: HOME_VISIT,
        allowedMaxTime: PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
    }
]
const AdditionalTestMapping = [
    {name : 'CRP', set : 'Test_0001'},
    {name : '2D Echo', set : 'Test_0002'},
    {name : 'Blood pressure', set : 'Test_0003'},
    {name : 'Blood Urea', set : 'Test_0004'},
    {name : 'BMI', set : 'Test_0005'},
    {name : 'Body temperature', set : 'Test_0006'},
    {name : 'Carcino Embryonic Antigen (CEA )', set : 'Test_0007'},
    {name : 'CBC - ESR', set : 'Test_0008'},
    {name : 'CBC - Hemogram', set : 'Test_0009'},
    {name : 'CBC - PS', set : 'Test_0010'},
    {name : 'Complete Lipid Profile (LDL,VLDL,TG,TC)', set : 'Test_0011'},
    {name : 'ECG', set : 'Test_0012'},
    {name : 'Erythrocyte Sedimentation Rate', set : 'Test_0013'},
    {name : 'FBS', set : 'Test_0014'},
    {name : 'GGT', set : 'Test_0015'},
    {name : 'H D L Cholestrol', set : 'Test_0016'},
    {name : 'HbA1C', set : 'Test_0017'},
    {name : 'HBsAg', set : 'Test_0018'},
    {name : 'Height', set : 'Test_0019'},
    {name : 'HIV 1&2', set : 'Test_0020'},
    {name : 'LDL Cholestrol', set : 'Test_0021'},
    {name : 'Liver Function Test (LFT)(SGOT,SGPT,GGT, Total Bilirubin)', set : 'Test_0022'},
    {name : 'Mammogram', set : 'Test_0023'},
    {name : 'Medical Examination Report', set : 'Test_0024'},
    {name : 'Opinion', set : 'Test_0025'},
    {name : 'PAP Smear', set : 'Test_0026'},
    {name : 'Peripheral smear (PS)', set : 'Test_0027'},
    {name : 'PFT', set : 'Test_0028'},
    {name : 'PSA', set : 'Test_0029'},
    {name : 'Pulse', set : 'Test_0030'},
    {name : 'Remarks/ Impressions', set : 'Test_0031'},
    {name : 'Renal Function Test (RFT) (Serum Creatinine, Uric acid, Blood Urea, Urine routine)', set : 'Test_0032'},
    {name : 'S.G.O.T.', set : 'Test_0033'},
    {name : 'S.G.P.T.', set : 'Test_0034'},
    {name : 'Serum Creatinine', set : 'Test_0035'},
    {name : 'T3', set : 'Test_0036'},
    {name : 'T4', set : 'Test_0037'},
    {name : 'Thyroid Profile: T3,T4,TSH', set : 'Test_0038'},
    {name : 'TMT', set : 'Test_0039'},
    {name : 'Total Bilirubin', set : 'Test_0040'},
    {name : 'Total Cholesterol', set : 'Test_0041'},
    {name : 'Triglycerides', set : 'Test_0042'},
    {name : 'TSH', set : 'Test_0043'},
    {name : 'Uric Acid', set : 'Test_0044'},
    {name : 'Urine Culture', set : 'Test_0045'},
    {name : 'Urine Routine', set : 'Test_0046'},
    {name : 'USG Abdomen', set : 'Test_0047'},
    {name : 'USG Abdomen + Pelvis', set : 'Test_0048'},
    {name : 'V.L.D.L', set : 'Test_0049'},
    {name : 'Weight', set : 'Test_0050'},
    {name : 'X ray chest', set : 'Test_0051'},
    {name : 'Video MER', set : 'TEST_Video12'},
    {name : 'Urine Micral', set : 'Test_0052'},
    {name : 'Blood Urea Nitrogen', set : 'Test_0053'}
    ];
export { medicalTestsConfiguration, AdditionalTestMapping };